import React, { useState, useEffect } from 'react'
import axios from 'axios'
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  ProgressBar,
} from 'react-bootstrap'
import { FaQuestionCircle, FaUser, FaEnvelope, FaCheck } from 'react-icons/fa'
import { motion, AnimatePresence } from 'framer-motion'
import { useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { data } from 'autoprefixer'

const pageVariants = {
  initial: { opacity: 0, x: '-100vw' },
  in: { opacity: 1, x: 0 },
  out: { opacity: 0, x: '100vw' },
}

const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 0.5,
}

export default function Quiz() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [currentQuestion, setCurrentQuestion] = useState(0)
  const [questions, setQuestions] = useState([])
  const [answers, setAnswers] = useState({})
  const [responses, setResponses] = useState([])
  const { quiz_id } = useParams()
  const [result, setResult] = useState(0)

  useEffect(() => {
    const token = localStorage.getItem('jwttoken')
    // Fetch the quiz data from the API
    axios
      .get(`https://kaasbackend.vetrinahealthcare.com/tms/quiz/${quiz_id}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setQuestions([...response.data.questions])
        console.log(questions)
      })
      .catch((error) => {
        console.error('There was an error fetching the quiz data!', error)
      })
  }, [quiz_id])

  const handleAnswerChange = (questionIndex, optionIndex) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionIndex]: optionIndex, // Save the index of the selected option
    }))
  }

  const handleNext = () => {
    setResponses((prevResponses) => {
      const updatedResponses = [...prevResponses]
      updatedResponses[currentQuestion - 1] = answers[currentQuestion - 1]
      return updatedResponses
    })

    if (currentQuestion <= questions.length) {
      setCurrentQuestion(currentQuestion + 1)
    }
  }

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const Submission = {
      name,
      email,
      responses,
    }
    console.log(Submission)
    setSubmitted(true)
    // const token = localStorage.getItem("jwttoken");
    axios
      .post(
        `https://kaasbackend.vetrinahealthcare.com/tms/quiz/${quiz_id}/submit/`,
        (data = Submission)
      )
      .then((response) => {
        setResult(response.data.percentage)
      })
      .catch((reason) => {
        console.log(reason)
        alert(reason)
      })
  }

  if (submitted) {
    return (
      <Container className='mt-5'>
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Card className='text-center' bg='light' border='success'>
            <Card.Body>
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: 'spring', stiffness: 260, damping: 20 }}
              >
                <FaCheck className='text-success mb-3' size={50} />
              </motion.div>
              {/* {console.log(result)} */}
              <Card.Title className='mb-4'>
                Thank you for your submission!
              </Card.Title>
              <Card.Text style={{ color: 'black' }}>
                Your responses have been recorded.
              </Card.Text>
              <Card.Text style={{ color: 'black' }}>
                Congrats you scored: {result}
              </Card.Text>
              {/* <Button variant="primary" onClick={() => window.location.reload()}>Take Another Quiz</Button> */}
            </Card.Body>
          </Card>
        </motion.div>
      </Container>
    )
  }
  return (
    <Container className='mt-5'>
      <Row>
        <Col md={8} className='mx-auto'>
          <motion.div
            initial='initial'
            animate='in'
            exit='out'
            variants={pageVariants}
            transition={pageTransition}
          >
            <Card className='shadow-lg border-0 rounded-lg'>
              <Card.Body className='p-5'>
                <motion.div
                  initial={{ y: -50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.2 }}
                >
                  <Card.Title className='text-center mb-5 display-6'>
                    <FaQuestionCircle className='me-2 text-primary' />
                    Assessment
                  </Card.Title>
                </motion.div>
                <Form onSubmit={handleSubmit}>
                  <AnimatePresence mode='wait'>
                    <motion.div
                      key={currentQuestion}
                      initial={{ opacity: 0, y: 50 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -50 }}
                      transition={{ duration: 0.5 }}
                    >
                      {currentQuestion === 0 && (
                        <>
                          <Form.Group className='mb-4'>
                            <Form.Label>
                              <FaUser className='me-2 text-primary' />
                              Name
                            </Form.Label>
                            <Form.Control
                              type='text'
                              placeholder='Enter your name'
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              required
                              className='form-control-lg'
                            />
                          </Form.Group>
                          <Form.Group className='mb-4'>
                            <Form.Label>
                              <FaEnvelope className='me-2 text-primary' />
                              Email address
                            </Form.Label>
                            <Form.Control
                              type='email'
                              placeholder='Enter your email'
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                              className='form-control-lg'
                            />
                          </Form.Group>
                        </>
                      )}
                      {currentQuestion > 0 &&
                        currentQuestion <= questions.length && (
                          <Form.Group className='mb-4'>
                            <Form.Label className='fw-bold fs-4 mb-3'>
                              {questions[currentQuestion - 1].question}
                            </Form.Label>
                            {questions[currentQuestion - 1].options.map(
                              (option, index) => (
                                <motion.div
                                  key={index}
                                  initial={{ opacity: 0, x: -50 }}
                                  animate={{ opacity: 1, x: 0 }}
                                  transition={{ delay: index * 0.1 }}
                                >
                                  <Form.Check
                                    type='radio'
                                    id={`q${currentQuestion}-option${index}`}
                                    label={option}
                                    name={`question-${currentQuestion}`}
                                    onChange={() =>
                                      handleAnswerChange(
                                        currentQuestion - 1,
                                        index
                                      )
                                    }
                                    checked={
                                      answers[currentQuestion - 1] === index
                                    }
                                    required
                                    className='mb-3 fs-5'
                                  />
                                </motion.div>
                              )
                            )}
                          </Form.Group>
                        )}
                    </motion.div>
                  </AnimatePresence>
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                  >
                    <ProgressBar
                      now={(currentQuestion / questions.length) * 100}
                      label={`${currentQuestion}/${questions.length}`}
                      className='mb-4'
                      variant='info'
                      animated
                    />
                    <div className='d-flex justify-content-between'>
                      <Button
                        variant='outline-secondary'
                        onClick={handlePrevious}
                        disabled={currentQuestion === 0}
                        size='lg'
                      >
                        Previous
                      </Button>
                      {currentQuestion <= questions.length ? (
                        <Button
                          variant='primary'
                          onClick={handleNext}
                          size='lg'
                        >
                          Next
                        </Button>
                      ) : (
                        <Button variant='success' type='submit' size='lg'>
                          Submit
                        </Button>
                      )}
                    </div>
                  </motion.div>
                </Form>
              </Card.Body>
            </Card>
          </motion.div>
        </Col>
      </Row>
    </Container>
  )
}
